import $ from 'jquery'

$(document).on('turbolinks:load', function () {
  const forms = document.querySelectorAll(
    'form[data-behaviour="enable-submit-on-change"]'
  )

  forms.forEach((form) => {
    const inputs = form.querySelectorAll('input, select, textarea')

    inputs.forEach((input) => {
      input.addEventListener('change', () => {
        const submitButton = form.querySelector('input[type="submit"]')

        if (submitButton) {
          submitButton.disabled = false
        }
      })
    })
  })
})
